module.exports = __webpack_public_path__ + "img/lesley-nneka-arimah.5b2eded5.png";